// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Manufacturer } from './manufacturer';
import { StagedProductType } from './staged-product-type';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class CatalogFeed extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Int32 key */
  id!: number;
  /** String(50) */
  name!: string;
  /** Inv FK catalogFeedId */
  manufacturers!: Manufacturer[];
  /** Inv FK catalogFeedId */
  stagedProductTypes!: StagedProductType[];
}

